<div class="row" >
  <div class="col-md-4">

      <div>
        <h5>Source Shop:</h5>
        <div class="p-inputgroup">
          <p-autoComplete   
          #sourceAutoComplete    
          [(ngModel)]="sourceShopSelected"    
          [suggestions]="sourceShopSuggestions"
          [delay]="1000"
          placeholder="Search"
          [field]="'name'"
          [forceSelection]="true"
          (onSelect)="selectShop($event, 'source')"
          (completeMethod)="searchShop($event, 'source')">
            <ng-template let-shop pTemplate="item">
              <div><span>{{shop.name}}</span></div>
            </ng-template>
          </p-autoComplete>
        </div>
      </div>
      
      <div style="margin-top:24px;">
        <h5>Destination Shop:</h5>
        <div class="p-inputgroup">
          <p-autoComplete 
          #destinationAutoComplete
          [(ngModel)]="destinationShopSelected"
          [suggestions]="destinationShopSuggestions"
          [delay]="1000"
          placeholder="Search"
          [field]="'name'"
          [forceSelection]="true"
          (onSelect)="selectShop($event, 'destination')"
          (completeMethod)="searchShop($event, 'destination')">
             <ng-template let-shop pTemplate="item">
              <div><span>{{shop.name}}</span></div>
            </ng-template>
          </p-autoComplete>
        </div>
      </div>
    
  </div>

  <div class="col-md-4">
    <h5>What would you like to copy</h5>
      <p-listbox 
        [options]="availableCopyOptions" 
        [(ngModel)]="selectedCopyOptions" 
        [multiple]="true" 
        [group]="true"
        [checkbox]="true"
        optionLabel="name" 
        optionGroupLabel="label" 
        optionGroupChildren="items"
        [listStyle]="{'max-height':'250px'}" 
        [showToggleAll]="false"
        [disabled]="!sourceShopSelected || !destinationShopSelected"
        (onChange)="onCopyOptionChange($event)">
      </p-listbox>
  </div>

  <div class="col-md-4">
    <h5>You will be copying:</h5>

    <ng-container *ngIf="displayedCopyOptions.length > 0; else noSelection">
      <div>
        <ul>
          <li *ngFor="let item of displayedCopyOptions">
            {{ item.name }}
            <span *ngIf="item.total !== null && item.total !== undefined">
              - {{ item.total }} records
            </span>
          </li>
        </ul>
      </div>
    </ng-container>
    
    <ng-template #noSelection>
      <p>Nothing selected to copy.</p>
    </ng-template>

    <div *ngIf="!busy">
      <button pButton type="button" class="p-button-raised" 
      (click)="confirmCopy()" 
      [disabled]="!sourceShopSelected || !destinationShopSelected || selectedCopyOptions.length <= 0 || busy"
      label="Copy more data"></button>
    </div>
    
    <div *ngIf="busy">
      <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
                         animationDuration=".5s">
      </p-progressSpinner>
    </div>

    <div *ngIf="!sourceShopSelected" class="text-danger">
      Please select a Source Shop.
    </div>
    <div *ngIf="!destinationShopSelected" class="text-danger">
      Please select a Destination Shop.
    </div>
    <div *ngIf="(!selectedCopyOptions || selectedCopyOptions.length === 0)" class="text-danger">
      Please select at least one Copy Option.
    </div>
  </div>
</div>

<p-toast position="top-center" styleClass="hubtiger-toast"></p-toast>